import { apiPostPpgSmartcare } from "../../../api";
import { ApiConnector } from "../../../api/api-connector";
import { markReadsStale } from "../../../api/query-client";
import { DataAdd } from "../../../models/data-add";
import { navigate } from "../../../utils/navigate";
import { Patient } from "../patient";

export class AddPPG extends DataAdd {
  ppgFile = new FormData();

  constructor(api: ApiConnector, patient: Patient) {
    super(api, patient);
    this.desc = "PPG data from SmartCare device (others not tested)";
    this.endpoint = "";
    this.defaultDateTime = null;
    this.reloadToTab = "raw/ppg";
  }

  async initEmpty() {
    this.addingList = {
      measurement_datetime: this.defaultDateTime,
      measurement_condition: null,
      measurement_device: "SmartCare BM2000A",
      measurement_origin: "finger",
      measurement_mode: 1,
      quality_flag: 1,
      comment: "",
    };
  }

  uploadFile(event: { target: HTMLInputElement }) {
    const file = event.target.files?.[0];
    if (file) this.ppgFile.set("ppg_file", file);
  }

  async post() {
    this.addingList.patient_id = this.patient.patientId;

    const response = await apiPostPpgSmartcare({
      body: this.ppgFile as any,
      bodySerializer: (body) => body,
      query: this.addingList,
    });
    if (response.data != null) {
      markReadsStale();
      navigate(`/patient/${this.patient.patientId}/${this.reloadToTab}`);
    }
  }
}
